module.exports = __webpack_public_path__ + "img/Picture9.b70740b3.png";